import { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { CustomGrid } from "../../components/tableComponent";
import { getJoinedLeague } from "../../services/leagues";
import { useNavigate } from "react-router-dom";
import pemdingLeaguesIcon from "../../styles/images/pendingLeagueIcon.svg";
import activeLeagueIcon from "../../styles/images/activeLeagueIcon.svg";

const JoinedLeaguesTable = () => {
  // State management
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortModel, setSortModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  // Column definitions
  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      sortable: true,
      flex: 1,
      renderCell: (params) => {
        console.log("params === ", params.row);
        return (
          <div className="d-flex flex-row align-items-center">
            <img
              src={
                params.row.league_status === "Upcoming" ? pemdingLeaguesIcon : activeLeagueIcon
              }
              alt="league"
            />
            <p
              className="league-name-cell"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/joined_leagues/${params.row.league_id}`);
              }}
            >
              {params.row.name}
            </p>
          </div>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 250,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "no_of_seasons",
      headerName: "# of Seasons",
      width: 150,
      sortable: true,
      flex: 1,
    },
    {
      field: "no_of_participants",
      headerName: "# of Participants",
      width: 150,
      sortable: true,
      flex: 1,
    },
  ];

  // Data fetching function
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getJoinedLeague();
      response.data.joined_leagues.map((ele, idx) => {
        console.log("element joined league === ", ele);
      });
      console.log("response", response);
      setData(
        response.data.joined_leagues.map((ele, idx) => ({ id: idx, ...ele }))
      );
      // setTotalRecords(response.data.conducted_leagues.length);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch data when dependencies change
  useEffect(() => {
    fetchData();
  }, [page, pageSize, sortModel]);

  // Event handlers
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to first page when changing page size
  };

  const handleSortChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleRowSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleRowClick = (params) => {
    console.log("Row clicked:", params.row);
    navigate(`/joined_leagues/${params.row.league_id}`);
  }

  // Loading state
  if (loading && !data.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      <CustomGrid
        columns={columns}
        data={data}
        loading={loading}
        perPageCount={pageSize}
        currentPage={page}
        totalPages={totalRecords}
        isServerPagination={false}
        // isServerSorting={true}
        onChangeRecords={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onSortModelChange={handleSortChange}
        onRowClick={handleRowClick}
        // checkboxSelection={true}
        onRowSelectionModelChange={handleRowSelectionChange}
        rowHeight={56}
        selectedCount={selectedRows.length}
        selectionModel={selectedRows}
        searchBar={null}
        disableSorting={true}
      />
    </Box>
  );
};

export default JoinedLeaguesTable;
